import React, { useState } from "react";
import { DropdownItem, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ContactField from "./ContactField";
import Contacts from "./Contacts";
import { toast } from "react-toastify";
import { proxyAPI } from "../proxyAPI";
import { useUpsertOneFieldMutation } from "../store/slices/contactsSlice";

function BulkEditModal({ contactField, selectedContacts, setFilter }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [append, setAppend] = useState(false);
  const [contact, setContact] = useState({ details: [] });

  const handleChange = ({ contactField: cf, values }) => {
    setContact((prev) => {
      if (!prev.details.some((detail) => detail.field.uuid === cf.uuid)) {
        return {
          ...prev,
          details: [
            ...prev.details,
            {
              values: values.map((v) => ({ data: v })),
              field: {
                uuid: cf.uuid,
              },
            },
          ],
        };
      }
      return {
        ...prev,
        details: prev.details.map((detail) => {
          if (detail.field.uuid === cf.uuid) {
            return {
              ...detail,
              values: values.map((v) => ({ data: v })),
            };
          }
          return detail;
        }),
      };
    });
  };

  const [save] = useUpsertOneFieldMutation();

  const handleSave = async () => {
    const body = {
      uuids: selectedContacts,
      field_uuid: contactField.uuid,
      values: contact.details[0].values.map((v) => v.data),
      value_is_uuid: contactField.isSelect,
      append,
    };
    const { data } = await save(body);

    if (data.isError) {
      toast.error(data.message);
      return;
    }
    if (data) {
      toast.success("Contacts updated successfully");
      setFilter((p) => [...p]);
      setShow(false);
    }
  };

  const [showContactFields, setShowContactFields] = useState([
    contactField.uuid,
  ]);
  const [showContactSets, setShowContactSets] = useState([]);

  return (
    <>
      <DropdownItem onClick={handleShow}>{contactField.label}</DropdownItem>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Update {contactField.label}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContactField
            key={contactField.uuid}
            contactField={contactField}
            contact={contact}
            handleChange={handleChange}
            errors={[]}
          />
          {contactField.isMultiple && (
            <div className="d-flex justify-content-end">
              <Form.Check
                label="Append"
                checked={append}
                onChange={(e) => setAppend(e.target.checked)}
                className="fs-5"
              />
            </div>
          )}
          <div className="mt-3">
          <Contacts
            fields={{
              uuids: showContactFields,
              cards: true,
              channels: true,
            }}
            showContactFields={showContactFields}
            useSearchOptions
            includeContacts={selectedContacts}
            contactSets={showContactSets}
            fullView={false}
          /></div>
          <Button
            variant=""
            className="bg-colored-reverse text-white fw-bold rounded-pill p-2 px-4 mt-3 float-end"
            onClick={handleSave}
          >
            Update selected contacts
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default BulkEditModal;
